class CollageGrid extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      grid: '[js-collage-grid]',
      block: '[js-collage-block]',
      blockText: '[js-collage-block-text]',
      showMoreBtn: '[js-show-more]'
    }
  }

  connectedCallback() {
    this.grid = this.querySelector(this.selectors.grid);
    this.blocks = this.querySelectorAll(this.selectors.block);
    this.showMoreBtn = this.querySelector(this.selectors.showMoreBtn);
    this._setEventListeners();
  }

  _setEventListeners = () => {
    if (this.showMoreBtn) this.showMoreBtn.addEventListener('click', this._toggleBlocks);
    this.blocks.forEach(block => {
      block.addEventListener('mouseenter', this._revealText);
      block.addEventListener('mouseleave', this._revealText);
    })
  }

  _toggleBlocks = (evt) =>{
    if (!this.showMoreBtn.classList.contains('flipped')){
      this.blocks.forEach((block, index) => {
        if (block.classList.contains('hide-block')){
          block.classList.remove('hide-block');
        }
      })
      this.showMoreBtn.classList.add('flipped');
    }
    else {
      this.showMoreBtn.classList.remove('flipped')
      this.blocks.forEach((block, index) => {
        if (index > 6){
          block.classList.add('hide-block');
        }
      })
    }
    console.log(this.showMoreBtn.classList)
  }

  _revealText = (evt) => {
    const block = evt.target;
    var text = block.querySelector(this.selectors.blockText);
    if (text) text.classList.toggle('hidden');
  }
}

customElements.define("collage-grid", CollageGrid);